module.exports = __webpack_public_path__ + "images/05cccc6b186540161aca408689df4327.png";